import { Button, Flex, Typography } from "antd"

export const WithdrawaWhitelistStepUI = () => {
  return (
    <Typography.Text>
      To withdraw cryptocurrency from your balance, you must first whitelist the
      recipient wallet address.
      <br />
      In the Whitelist section under Settings, you can add any necessary
      addresses for withdrawals. Once added, the address will be available for
      selection within one hour
    </Typography.Text>
  )
}
